export default __webpack_public_path__ + "static/media/workingWithDroneForestApp.740a894e.pdf";